module.exports = __webpack_public_path__ + "static/media/icons8-close.586bb873.svg";